import { useGetWordMatsForOrganisationQuery } from '@/app/redux/endpoints/wordMats';
import { useCurrentOrganisationId } from '@/app/redux/hooks/organisation';
import { WordMat } from '@/common/types/wordMat';
import { useMemo } from 'react';

export function useWordMats() {
  const { currentOrganisationId } = useCurrentOrganisationId();
  const skip = !currentOrganisationId;

  const { data: wordMats = [], isLoading, isFetching, error } =
    useGetWordMatsForOrganisationQuery(currentOrganisationId!, { skip });

  const wordMatsById = useMemo(() => {
    const byId = new Map<string, WordMat>();
    for (const wm of wordMats) byId.set(wm.id, wm);
    return byId;
  }, [wordMats]);

  return { wordMats, wordMatsById, isLoading, isFetching, error };
}
